import axios from "axios";

export default class CoverageFinderService {
  static classInstance = null;
  static getInstance() {
    if (CoverageFinderService.classInstance === null) {
      CoverageFinderService.classInstance = new CoverageFinderService();
    }
    return this.classInstance;
  }

  async getCoverageFinderInfo(token,projectType) {
    const apiEndPoint=projectType==="CF"?"coverage/getclientcoverageprojectInfo/":"coverage/getpatientclientcoverageprojectInfo/";
    const url = `${process.env.REACT_APP_CF_API_URL}${apiEndPoint}${token}`;
    const coverage = await axios.get(url).then(
      (response) => {
        return response.data;
      },
      (error) => {
        console.error(error);
      }
    );
    return coverage;
  }
}
